import Apis from 'constants/api';
import _filter from 'lodash/filter';
import _get from 'lodash/get';
import _map from 'lodash/map';
import _omitBy from 'lodash/omitBy';
import _startsWith from 'lodash/startsWith';
import request from 'utils/http';
import Icons from 'constants/icons';
import { showError, showSuccess, showWarning } from 'service/notifications/action';
import { startLoading, stopLoading } from 'service/loader/action';
import actionTypes from './actionTypes';

export const getBlocDataExplorerRecords = (schemaName, customDateFilter) => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.refData.blocDataExplorerRecords, {
            params: {
                schemaName,
                customDateFilter,
            },
        })
        .then(({ data: { data } }) => {
            dispatch({
                type: actionTypes.GET_BLOCDATAEXPLORER_RECORDS_SUCCESS,
                payload: data,
            });
            dispatch(stopLoading());
        })
        .catch((error) => {
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
            dispatch({
                type: actionTypes.GET_BLOCDATAEXPLORER_RECORDS_FAILURE,
                payload: [],
            });
        });
};

export const getSourceDataExplorerRecords = (schemaName, customDateFilter) => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.refData.sourceDataExplorerRecords, {
            params: {
                schemaName,
                customDateFilter,
            },
        })
        .then(({ data: { data } }) => {
            dispatch({
                type: actionTypes.GET_SOURCEDATAEXPLORER_RECORDS_SUCCESS,
                payload: data,
            });
            dispatch(stopLoading());
        })
        .catch((error) => {
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
            dispatch({
                type: actionTypes.GET_SOURCEDATAEXPLORER_RECORDS_FAILURE,
                payload: [],
            });
        });
};

export const cleanSourceData = () => (dispatch) => {
    dispatch({
        type: actionTypes.GET_BLOCDATAEXPLORER_RECORDS_SUCCESS,
        payload: {
            columns: [],
            records: [],
            columnDefinitions: [],
        },
    });
};

export const getRefDataGoldenCopyExplorerRecords = (schemaName) => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.refData.refDataGoldenCopyExplorerRecords, {
            params: {
                schemaName,
            },
        })
        .then(({ data: { data } }) => {
            dispatch({
                type: actionTypes.GET_REFDATAGOLDENEXPLORER_RECORDS_SUCCESS,
                payload: data,
            });
            dispatch(stopLoading());
        })
        .catch((error) => {
            console.log('error', error);
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const getRefDataGoldenCopyLinkedRecords =
    (groupRefId, linkedGroupName, state, isHistory = false) =>
        (dispatch) => {
            const stateData = _get(state, 'data', {}) || {};
            const linkedStateData = Object.keys(stateData).reduce((result, key) => {
                if (key !== 'bloc_data_merged_gcs' && !key.toLowerCase().startsWith('values_')) result[key] = stateData[key];
                return result;
            }, {});
            dispatch(startLoading());
            request
                .get(Apis.refData.linkedGcData, {
                    params: {
                        groupRefId,
                        linkedGroupName,
                        isHistory,
                        ...linkedStateData,
                    },
                })
                .then(({ data: { data } }) => {
                    dispatch({
                        type: actionTypes.GET_REF_DATA_LINKED_GROUP_RECORDS,
                        payload: data,
                    });
                    dispatch(stopLoading());
                })
                .catch((error) => {
                    console.log('error', error);
                    dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
                    dispatch(stopLoading());
                });
        };

export const fetchLinkedGcRecordsByGroup =
    (groupRefId, linkedGroupName, state, isHistory = false) =>
        () => {
            const stateData = _get(state, 'data', {}) || {};
            const linkedStateData = Object.keys(stateData).reduce((result, key) => {
                if (key !== 'bloc_data_merged_gcs' && !key.toLowerCase().startsWith('values_')) result[key] = stateData[key];
                return result;
            }, {});
            return request
                .get(Apis.refData.linkedGcData, {
                    params: {
                        groupRefId,
                        linkedGroupName,
                        isHistory,
                        ...linkedStateData,
                    },
                })
                .then(({ data: { data } }) => data || {});
        };

/**
 * Record-scoped responses (history, source contribution) in shared redux, and a
 * nested golden copy screen requests them for another record.
 * Each response is tagged with the record it was requested for so a screen can ignore data
 */
export const buildRecordRequest = (gcId, schemaName) => ({
    gcId: String(gcId == null ? '' : gcId),
    schemaName: String(schemaName || '').toLowerCase(),
});

export const isRecordRequestFor = (recordRequest, gcId, schemaName) => {
    if (!recordRequest) return false;
    const expected = buildRecordRequest(gcId, schemaName);
    return recordRequest.gcId === expected.gcId && recordRequest.schemaName === expected.schemaName;
};

export const getRefDataHistory = (gc_id, schemaName) => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.refData.history, {
            params: {
                gc_id: gc_id,
                groupName: schemaName,
            },
        })
        .then(({ data: { data } }) => {
            dispatch({
                type: actionTypes.GET_GROUP_HISTORY_DATA,
                payload: data,
                meta: buildRecordRequest(gc_id, schemaName),
            });
            dispatch(stopLoading());
        })
        .catch((error) => {
            console.log('error', error);
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const getGcId = () => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.refData.uniqueGcId)
        .then(({ data: { data } }) => {
            dispatch({
                type: actionTypes.GET_GROUP_GC_ID,
                payload: data,
            });
            dispatch(stopLoading());
        })
        .catch((error) => {
            console.log('error', error);
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const getRefDataLineage = (gcRowData, schemaName) => (dispatch) => {
    dispatch(startLoading());
    const payload = {
        ...gcRowData,
        groupName: schemaName,
    };
    request
        .post(Apis.refData.dataLineage, payload)
        .then(({ data: { data } }) => {
            dispatch({
                type: actionTypes.GET_GROUP_LINEAGE_DATA,
                payload: data,
            });
            dispatch(stopLoading());
        })
        .catch((error) => {
            console.log('error', error);
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const getHistoricValues = (payload) => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.refData.gcHistoricData, {
            params: payload,
        })
        .then(({ data: { data } }) => {
            dispatch({
                type: actionTypes.GET_GC_HISTORIC_DATA,
                payload: data,
            });
            dispatch(stopLoading());
        })
        .catch((error) => {
            console.log('error', error);
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const getPreviousValues = (payload) => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.refData.previousData, {
            params: payload,
        })
        .then(({ data: { data } }) => {
            dispatch({
                type: actionTypes.GET_GC_PREVIOUS_DATA,
                payload: data,
            });
            dispatch(stopLoading());
        })
        .catch((error) => {
            console.log('error', error);
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const createChangeHistoryView = (payload) => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.refData.createChangeHistoryView, {
            params: payload,
        })
        .then(({ data: { data } }) => {
            dispatch(stopLoading());
        })
        .catch((error) => {
            console.log('error', error);
            dispatch(showWarning(`Unable to create change history view`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const getLinkedGroups = (payload) => (dispatch) => {
    // dispatch(startLoading());
    request
        .get(Apis.refData.linkedGroups, {
            params: payload,
        })
        .then(({ data: { data } }) => {
            dispatch({
                type: actionTypes.GET_LINKED_GROUPS,
                payload: data,
            });
            // dispatch(stopLoading());
        })
        .catch((error) => {
            console.log('error', error);
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            // dispatch(stopLoading());
        });
};

export const getLinkedDDData = (payload) => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.refData.linkedDDData, {
            params: payload,
        })
        .then(({ data: { data } }) => {
            console.log(data);
            dispatch({
                type: actionTypes.GET_LINKED_DD_DATA,
                payload: data,
            });
            dispatch(stopLoading());
        })
        .catch((error) => {
            console.log('error', error);
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const cleanLineageData = () => (dispatch) => {
    dispatch({
        type: actionTypes.GET_GROUP_LINEAGE_DATA,
        payload: [],
    });
};

export const cleanGoldenCopyData = () => (dispatch) => {
    dispatch({
        type: actionTypes.GET_REFDATAGOLDENEXPLORER_RECORDS_SUCCESS,
        payload: {
            columns: [],
            records: [],
            columnDefinitions: [],
        },
    });
};

export const getAllBlocDataExplorerSchemas = () => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.refData.blocDataExplorerSchemas)
        .then(({ data: { data } }) => {
            dispatch({
                type: actionTypes.GET_ALL_BLOCDATAEXPLORER_NAMES_SUCCESS,
                payload: data,
            });
        })
        .catch((error) => {
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const getAllRefDataGoldenExplorerSchemas = () => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.refData.refDataGoldenCopySchemas)
        .then(({ data: { data } }) => {
            dispatch({
                type: actionTypes.GET_ALL_REFDATAGOLDENEXPLORER_NAMES_SUCCESS,
                payload: data,
            });
        })
        .catch((error) => {
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const getMergeIdRecordsForGc = async (payload) => {
    return await request
        .post(Apis.refData.mergeRecords, payload)
        .then(({ data: { data } }) => data)
        .catch((error) => []);
};

export const getGroupLockInfo = async (groupRefId) => {
    return await request
        .get(Apis.refData.groupLock, { params: { groupRefId } })
        .then(({ data: { data } }) => data || [])
        .catch((error) => []);
};

export const getGcRecordByGcId = async (payload) => {
    return await request
        .get(Apis.refData.gcRecord, { params: payload })
        .then(({ data: { data } }) => data)
        .catch((error) => null);
};

export const getTradesChartData = () => (dispatch) => {
    // dispatch(startLoading());
    request
        .get(Apis.refData.tradesChartData)
        .then(({ data: { data } }) => {
            dispatch({
                type: actionTypes.GET_TRADES_CHARTS_DATA,
                payload: data,
            });
        })
        .catch((error) => {
            dispatch({
                type: actionTypes.GET_TRADES_CHARTS_DATA,
                payload: {},
            });
            // dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            // dispatch(stopLoading());
        });
};

export const cleanTradesChart = () => (dispatch) => {
    dispatch({
        type: actionTypes.GET_TRADES_CHARTS_DATA,
        payload: {},
    });
};

export const deleteBlocDataExplorerAsset = (payload) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.refData.blocDataExplorerDeleteRecord, {
            payload,
        })
        .then(({ data: { data } }) => {
            dispatch(showSuccess(`${payload.asset_id} trade Deleted successfully`, Icons.thumbsUp));
            dispatch(stopLoading());
        })
        .catch(({ response }) => {
            const error = _get(response.data, 'error', null);
            if (error) {
                const { message } = error;
                dispatch(showError(message, Icons.thumbsDown));
            } else {
                dispatch(showError('Failed deleting the record', Icons.thumbsDown));
            }
            dispatch(stopLoading());
        });
};

export const updateBlocDataExplorerAsset = (tableName, payload, tableInfo) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.refData.blocDataExplorerUpdateRecord, {
            payload,
            tableName,
            tableInfo,
        })
        .then(({ data: { data } }) => {
            let finalPayload = [];
            for (let i = 0; i < data.length; i++) {
                finalPayload.push({
                    ...payload,
                    grouptype: data[i].group_name,
                    action_type: 'refDataRequest',
                });
            }
            dispatch(updateBlocDataRequest(finalPayload));
            dispatch(showSuccess(`${payload.asset_id} trade updated successfully`, Icons.thumbsUp));
            dispatch(stopLoading());
        })
        .catch(({ response }) => {
            const error = _get(response.data, 'error', null);
            if (error) {
                const { message } = error;
                dispatch(showError(message, Icons.thumbsDown));
            } else {
                dispatch(showError('Failed editing the record', Icons.thumbsDown));
            }
            dispatch(stopLoading());
        });
};

export const createBlocDataExplorerAsset = (tableName, payload, tableInfo) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.refData.blocDataExplorerCreateRecord, {
            payload,
            tableName,
            tableInfo,
        })
        .then(({ data: { data } }) => {
            dispatch(showSuccess(`New trade created successfully`, Icons.thumbsUp));
            dispatch(stopLoading());
        })
        .catch((error) => {
            dispatch(stopLoading());
        });
};

export const createGoldenCopyExplorerAsset = (groupName, payload, refreshManualMatchings) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.refData.goldenCopyExplorerCreateRecord, {
            payload,
            groupName,
        })
        .then(({ data: { data } }) => {
            dispatch(showSuccess(`New trade created successfully`, Icons.thumbsUp));
            refreshManualMatchings();
            dispatch(stopLoading());
        })
        .catch((error) => {
            dispatch(stopLoading());
        });
};

export const mergeGoldenCopyExplorerAsset = (payload, refreshGrid) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.refData.mergeGoldenCopyExplorerRecord, payload)
        .then(({ data: { data } }) => {
            dispatch(showSuccess(`Golden Copy merged successfully`, Icons.thumbsUp));
            if (refreshGrid) refreshGrid(data);
            dispatch(stopLoading());
        })
        .catch((error) => {
            console.log(error);
            dispatch(showError(error.response?.data?.error?.message || 'Unable to merge Golden Copy'));
            dispatch(stopLoading());
        });
};

export const unmergeGoldenCopyExplorerAsset = (payload, refreshGrid) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.refData.mergeGoldenCopyExplorerRecord, { ...payload, action: 'demerge', isMerge: false })
        .then(({ data: { data } }) => {
            dispatch(showSuccess(`Golden Copy unmerged successfully`, Icons.thumbsUp));
            if (refreshGrid) refreshGrid(data);
            dispatch(stopLoading());
        })
        .catch((error) => {
            console.log(error);
            dispatch(showError(error.response?.data?.error?.message || 'Unable to unmerge Golden Copy'));
            dispatch(stopLoading());
        });
};

export const insertGcDataRequest = (groupName, payload, refreshManualMatchings) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.spring.match.gcDataRequest, payload)
        .then(({ data }) => {
            dispatch({
                type: actionTypes.ADD_API_LOGGERS,
                payload: {
                    request: JSON.stringify(payload),
                    response: data,
                    requestURL: Apis.spring.match.gcDataRequest,
                },
            });
            if (refreshManualMatchings) refreshManualMatchings();
            dispatch(showSuccess('Golden Copy Updated Successfully'));
            dispatch(stopLoading());
        })
        .catch((error) => {
            console.log(error);
            dispatch({
                type: actionTypes.ADD_API_LOGGERS,
                payload: {
                    request: JSON.stringify(payload),
                    response: 'API Failed',
                    requestURL: Apis.spring.match.gcDataRequest,
                },
            });
            dispatch(stopLoading());
        });
};

export const createAssetRequestEngine = (payload, explorerName) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.infiniteTableProperties.newAssetRequest, payload)
        .then(({ data }) => {
            dispatch({
                type: actionTypes.ADD_API_LOGGERS,
                payload: {
                    request: JSON.stringify(payload),
                    response: data,
                    requestURL: Apis.infiniteTableProperties.newAssetRequest,
                },
            });
            dispatch(showSuccess(`New trade created successfully`, Icons.thumbsUp));
            dispatch(stopLoading());
        })
        .catch((error) => {
            console.log(error);
            dispatch({
                type: actionTypes.ADD_API_LOGGERS,
                payload: {
                    request: JSON.stringify(payload),
                    response: 'API Failed',
                    requestURL: Apis.infiniteTableProperties.newAssetRequest,
                },
            });
            dispatch(stopLoading());
        });
};

export const createMatchingRequest =
    (payload, explorerName, updateModal, inGridEnabled = false) =>
        (dispatch) => {
            dispatch(startLoading());
            request
                .post(Apis.infiniteTableProperties.newEngineRequest, payload)
                .then(({ data }) => {
                    dispatch({
                        type: actionTypes.ADD_API_LOGGERS,
                        payload: {
                            request: JSON.stringify(payload),
                            response: data,
                            requestURL: Apis.infiniteTableProperties.newEngineRequest,
                        },
                    });
                    if (payload.requestType === 'DELETE_GC_REQUEST') {
                        dispatch(showSuccess(`Record deleted successfully`, Icons.thumbsUp));
                    } else if (inGridEnabled) {
                        dispatch(showSuccess(`GC updated successfully`, Icons.thumbsUp));
                    } else dispatch(showSuccess(`New trade created successfully`, Icons.thumbsUp));
                    if (updateModal) updateModal();
                    dispatch(stopLoading());
                })
                .catch(({ response }) => {
                    // console.log(response);
                    const error = _get(response.data, 'error', null);
                    if (error) {
                        dispatch(showWarning(`Failed to Update GC`, Icons.thumbsDown));
                    }
                    dispatch({
                        type: actionTypes.ADD_API_LOGGERS,
                        payload: {
                            request: JSON.stringify(payload),
                            response: 'API Failed',
                            requestURL: Apis.infiniteTableProperties.newEngineRequest,
                        },
                    });
                    if (updateModal) updateModal();
                    dispatch(stopLoading());
                });
        };

export const createAssetImport = (payload, explorerName) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.spring.enrich.newImportAssetRequestBulk, payload)
        .then(({ data }) => {
            dispatch({
                type: actionTypes.ADD_API_LOGGERS,
                payload: {
                    request: JSON.stringify(payload),
                    response: data,
                    requestURL: Apis.spring.enrich.newImportAssetRequestBulk,
                },
            });
            dispatch(showSuccess(`New trade created successfully`, Icons.thumbsUp));
            dispatch(stopLoading());
        })
        .catch((error) => {
            console.log(error);
            dispatch({
                type: actionTypes.ADD_API_LOGGERS,
                payload: {
                    request: JSON.stringify(payload),
                    response: 'API Failed',
                    requestURL: Apis.spring.enrich.updateAssets,
                },
            });
            dispatch(stopLoading());
        });
};

export const getLinkedRecords = (payload) => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.refData.linkedGroupRecords, {
            params: payload,
        })
        .then(({ data: { data } }) => {
            dispatch({
                type: actionTypes.GET_LINKED_RECORDS,
                payload: data,
            });
            dispatch(stopLoading());
        })
        .catch((error) => {
            dispatch(stopLoading());
        });
};

export const updateBlocDataRequest =
    (payload, groupName, customDateFilter = -1, isGroupData = false, refreshManualMatchings) =>
        (dispatch) => {
            dispatch(startLoading());
            request
                .post(Apis.spring.match.blocDataRequest, payload)
                .then(({ data }) => {
                    dispatch({
                        type: actionTypes.ADD_API_LOGGERS,
                        payload: {
                            request: JSON.stringify(payload),
                            response: data,
                            requestURL: Apis.spring.match.blocDataRequest,
                        },
                    });
                    if (isGroupData) {
                        refreshManualMatchings();
                    }
                    dispatch(stopLoading());
                })
                .catch((error) => {
                    console.log(error);
                    dispatch({
                        type: actionTypes.ADD_API_LOGGERS,
                        payload: {
                            request: JSON.stringify(payload),
                            response: 'API Failed',
                            requestURL: Apis.spring.match.blocDataRequest,
                        },
                    });
                    dispatch(stopLoading());
                });
        };

export const updateGcWithIgnored = (payload, refreshManualMatchings) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.refData.markAsIgnored, payload)
        .then(({ data }) => {
            dispatch(stopLoading());
            refreshManualMatchings();
        })
        .catch((error) => {
            console.log(error);
            dispatch({
                type: actionTypes.ADD_API_LOGGERS,
                payload: {
                    request: JSON.stringify(payload),
                    response: 'API Failed',
                    requestURL: Apis.spring.match.blocDataRequest,
                },
            });
            dispatch(stopLoading());
        });
};

export const filterTableRecordsByCreatedDate = (sourceName, sourceType, startDate, endDate) => (dispatch) => {
    console.log(sourceName, sourceType, startDate, endDate);
    dispatch(startLoading());
    request
        .post(Apis.refData.blocDataExplorerfilterByCreatedDate, {
            sourceName,
            sourceType,
            startDate,
            endDate,
        })
        .then(({ data: { data } }) => {
            dispatch({
                type: actionTypes.GET_BLOCDATAEXPLORER_RECORDS_SUCCESS,
                payload: data,
            });
            dispatch(stopLoading());
        })
        .catch((error) => {
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
            dispatch({
                type: actionTypes.GET_BLOCDATAEXPLORER_RECORDS_FAILURE,
                payload: [],
            });
        });
};

export const filterByClientId = (client_id, schemaName) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.refData.refDataGoldenCopyExplorerRecordsByClientId, { client_id, schemaName })
        .then(({ data: { data } }) => {
            dispatch({
                type: actionTypes.GET_REFDATAGOLDENEXPLORER_RECORDS_BY_ID_SUCCESS,
                payload: data,
            });
            dispatch(stopLoading());
        })
        .catch((error) => {
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const getSourceItems = (sourcetype, groupName, asset_id) => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.refData.sourceSummaryData, { params: { sourcetype, groupName, asset_id } })
        .then(({ data: { data } }) => {
            dispatch({
                type: actionTypes.GET_SOURCE_SUMMARY_DATA,
                payload: data,
            });
            dispatch(stopLoading());
        })
        .catch((error) => {
            console.log(error);
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const getSourceData = (payload) => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.refData.sourceData, { params: { ...payload } })
        .then(({ data: { data } }) => {
            dispatch({
                type: actionTypes.GET_SOURCE_DATA_RECORDS_SUCCESS,
                payload: data,
            });
            dispatch(stopLoading());
        })
        .catch((error) => {
            console.log(error);
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const getSourceContribution = (payload) => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.refData.sourceContribution, { params: { ...payload } })
        .then(({ data: { data } }) => {
            dispatch({
                type: actionTypes.GET_SOURCE_DATA_CONTRIBUTION_SUCCESS,
                payload: data,
                meta: buildRecordRequest(payload.gcId, payload.schemaName),
            });
            dispatch(stopLoading());
        })
        .catch((error) => {
            console.log(error);
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const createAuthGcUpdate = (payload, updateModal, schemaName, dashboardName) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.refData.gcUpdate, payload)
        .then(({ data: { data } }) => {
            // dispatch({
            //     type: actionTypes.GET_GC_HISTORIC_DATA,
            //     payload: data,
            // });
            dispatch(getRecordsForAuthorizations(schemaName, dashboardName));
            dispatch(showSuccess('Maker action added successfully'));
            if (updateModal) updateModal();
            dispatch(stopLoading());
        })
        .catch((error) => {
            console.log('error', error);
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const updateAuth = (payload, status, makerId, isAdd, refreshGrid) => (dispatch) => {
    dispatch(startLoading());
    request
        .put(Apis.refData.auth, {
            payload,
            status,
            makerId,
            isAdd,
        })
        .then(({ data }) => {
            if (status === 'approve') {
                dispatch(createMatchingRequest(payload[0], null, refreshGrid));
            } else {
                dispatch(getRecordsForAuthorizations(payload[0].group_name, 'GC_EXPLORER'));
                refreshGrid(true);
            }
            dispatch(showSuccess(`${status === 'approve' ? 'Approval' : 'Rejection'} successful`, Icons.thumbsUp));
            dispatch(stopLoading());
        })
        .catch(({ response }) => {
            console.log(response);

            const error = _get(response.data, 'error', null);
            if (error) {
                const { message } = error;
                dispatch(showError(message, Icons.thumbsDown));
            } else {
                dispatch(showWarning(`Failed to update checker action`, Icons.thumbsDown));
            }
            dispatch(stopLoading());
        });
};

export const getRecordsForAuthorizations =
    (schemaName, dashboardName = 'GC_EXPLORER') =>
        (dispatch) => {
            // dispatch(startLoading());
            request
                .get(Apis.refData.auth, { params: { schemaName, dashboardName } })
                .then(({ data: { data } }) => {
                    dispatch({
                        type: actionTypes.GET_RECORDS_FOR_AUTHORIZATION,
                        payload: data,
                    });
                    // dispatch(stopLoading());
                })
                .catch((error) => {
                    console.log(error);
                    dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
                    // dispatch(stopLoading());
                });
        };

export const cleanLinkedGroups = () => (dispatch) => {
    dispatch({
        type: actionTypes.CLEAN_LINKED_GROUPS,
        payload: [],
    });
};

export const cleanLinkedRecords = () => (dispatch) => {
    dispatch({
        type: actionTypes.GET_REF_DATA_LINKED_GROUP_RECORDS,
        payload: [],
    });
    dispatch({
        type: actionTypes.CLEAN_REF_DATA_LINKED_GROUP_RECORDS_BY_GROUP,
    });
};

export const sourceReprocess = (payload) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.spring.enrich.reprocessSource, payload)
        .then(({ data }) => {
            dispatch({
                type: actionTypes.ADD_API_LOGGERS,
                payload: {
                    request: JSON.stringify(payload),
                    response: data,
                    requestURL: Apis.spring.enrich.reprocessSource,
                },
            });
            dispatch(showSuccess(`Reprocessed successfully`, Icons.thumbsUp));
            dispatch(stopLoading());
        })
        .catch((error) => {
            console.log(error);
            dispatch({
                type: actionTypes.ADD_API_LOGGERS,
                payload: {
                    request: JSON.stringify(payload),
                    response: 'API Failed',
                    requestURL: Apis.spring.enrich.updateAssets,
                },
            });
            dispatch(stopLoading());
        });
};

export const getDuplicateDetectionFields = (groupRefId, onSuccess) => (dispatch) => {
    request
        .get(Apis.refData.duplicateDetectionFields, {
            params: { groupRefId },
        })
        .then(({ data: { data } }) => {
            if (onSuccess) onSuccess(data || []);
        })
        .catch((error) => {
            console.log('error', error);
            dispatch(showWarning(`Unable to Fetch Duplicate Detection Fields ,`, Icons.thumbsUp));
        });
};

export const getDuplicateConditions = (groupName, onSuccess) => (dispatch) => {
    request
        .get(Apis.refData.duplicateConditions, { params: { groupName } })
        .then(({ data: { data } }) => {
            if (onSuccess) onSuccess(data || []);
        })
        .catch((error) => {
            console.log('error', error);
            dispatch(showWarning(`Unable to Fetch Duplicate Conditions ,`, Icons.thumbsUp));
        });
};

export const getMergeAudit = (groupName, mergeId, onSuccess) => (dispatch) => {
    request
        .get(Apis.refData.mergeAudit, { params: { groupName, mergeId } })
        .then(({ data: { data } }) => {
            if (onSuccess) onSuccess(data || []);
        })
        .catch((error) => {
            console.log('error', error);
            dispatch(showWarning(`Unable to Fetch Merge Audit ,`, Icons.thumbsUp));
        });
};

export const runDuplicateDetection = (payload, onSuccess) => async (dispatch) => {
    dispatch(startLoading());
    let duplicateConditionId;
    try {
        const { data: { data } } = await request.post(Apis.refData.duplicateCondition, {
            groupName: payload.groupName,
            condition: payload,
        });
        duplicateConditionId = _get(data, 'id', null);
    } catch (error) {
        console.log(error);
        dispatch(showError('Unable to record the duplicate detection run'));
        dispatch(stopLoading());
        return;
    }

    const enginePayload = { ...payload, duplicateConditionId };
    request
        .post(Apis.spring.match.duplicateDetection, enginePayload)
        .then(({ data }) => {
            dispatch({
                type: actionTypes.ADD_API_LOGGERS,
                payload: {
                    request: JSON.stringify(enginePayload),
                    response: data,
                    requestURL: Apis.spring.match.duplicateDetection,
                },
            });
            dispatch(showSuccess(`Duplicate detection rule triggered`, Icons.thumbsUp));
            if (onSuccess) onSuccess(data);
            dispatch(stopLoading());
        })
        .catch((error) => {
            console.log(error);
            dispatch({
                type: actionTypes.ADD_API_LOGGERS,
                payload: {
                    request: JSON.stringify(enginePayload),
                    response: 'API Failed',
                    requestURL: Apis.spring.match.duplicateDetection,
                },
            });
            dispatch(showError('Unable to trigger duplicate detection rule'));
            dispatch(stopLoading());
        });
};

export const mergeAllGoldenCopies = (payload, onSuccess) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.spring.match.mergeAll, payload)
        .then(({ data }) => {
            dispatch(showSuccess('All Golden Copies merged successfully', Icons.thumbsUp));
            dispatch(stopLoading());
            if (onSuccess) onSuccess(data);
        })
        .catch((error) => {
            console.log(error);
            dispatch(showError('Unable to merge all Golden Copies'));
            dispatch(stopLoading());
        });
};
